import { apiFetch } from './client.js';

/**
 * Recarga de tokens comprable (catálogo eko27 + precio Stripe).
 * Vigente: kit_3m — Recarga 3M ($599 MXN).
 */
export interface StorePack {
  id: string;
  label: string;
  tokens: number;
  /** tokens / 10,000 (aditivo). */
  creditos?: number;
  /** Precio en la moneda indicada. null = sin precio configurado (no comprable). */
  amount: number | null;
  currency: string;
}

/** Recarga a la medida (kit_custom): rango, paso y tramos. Vista previa; el precio real lo fija eko27. */
export interface PanteonCfg {
  id: string;
  nombre: string;
  min: number;
  max: number;
  paso: number;
  tramos: Array<{ desde: number; hasta: number; precio_credito: number }>;
}

export function getStorePacks(): Promise<{ available: boolean; packs: StorePack[]; panteon?: PanteonCfg }> {
  return apiFetch('/api/v1/store/packs');
}

/** Crea la sesión de Stripe Checkout; la URL se abre en una pestaña nueva. */
export function createStoreCheckout(kind: string, creditos?: number): Promise<{ url: string }> {
  return apiFetch('/api/v1/store/checkout', { method: 'POST', body: creditos != null ? { kind, creditos } : { kind } });
}
